import { getToken, postToPage } from '@/utils/utils';
import EnvUtils from './utils/EnvUtils';

const makeToPageFn = function (url, native) {
  return function () {
    // 生产环境 局域网或者本地化
    if (EnvUtils.is('production', true) && /localhost/.test(window.location.host)) {
      url = native;
    }
    postToPage(url, [
      {
        name: 'token',
        value: getToken()
      }
    ]);
  };
};

export default [
  {
    title: '知识图谱',
    icon: 'iconfont icon-zhishitupu',
    code: '010207',
    click: makeToPageFn(EnvUtils.get('KGRAPH_URL'))
  },
  {
    title: '后台管理',
    icon: 'iconfont icon-setting',
    code: '010205',
    click: makeToPageFn(EnvUtils.get('ADMIN_URL'), '/admin/a/login')
  }
];
